import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { StatisticsCode } from '@entity/statistics-code';
import { ContextService } from '@service/context.service';
import { StatisticsCodeService } from '@service/statistics-code.service';

export const StatisticsCodeResolve: ResolveFn<StatisticsCode> = (route) => {
  return inject(StatisticsCodeService).get(inject(ContextService).getMandantIdInstant(), route.params.id);
};
